<template>
    <section class="section-lophoc-member">
        <div class="ss-breadcrumb">
            <div class="container-hts">
                <ul class="margin-0 p-0">
                    <li><router-link to="/danh-sach-lop-hoc">Lớp học</router-link></li>
                </ul>
            </div>
        </div>
        <div class="container">
            <b-tabs class="pre-class-school-list__filter__tabs">
                <b-tab title="Lớp học của tôi" :active="tabActive == tabClassSchool">
                    <div class="pre-class-school-list__filter__action display-flex display-flex-space-between">
                        <div class="wrap-left display-flex">
                            <div class="item item__key input-custom-icon">
                                <input v-model.lazy="paramQueryData.keyword" v-debounce="300" type="text"
                                    placeholder="Tìm kiếm lớp theo tên"
                                    class="primary-color-txt color_bg_gray_light border-rd-20 font-size-15 form-h30 border-0 full-width">
                                <i class="icon-search font-size-16 primary-color"></i>
                            </div>
                            <!-- <a href="javascript:;" @click="toggleCollapseGroup"
                                class="btn-collapse btn border-rd-20 font-size-15 filter-btn"
                                :class="{ 'btn-main': openCollapseFilterGroup, 'btn-main-light': !openCollapseFilterGroup }">
                                Bộ lọc <i class="icon-arrow-down font-size-12"
                                    :class="{ 'color-light': openCollapseFilterGroup, 'primary-color': !openCollapseFilterGroup }"></i>
                            </a> -->
                            <div class="col-md-6">
                                <!-- <div class="filter__title secondary-color-txt font-sanpro-semibold">Bộ môn</div> -->
                                <b-form-select class="list-subject" @change="handleChangeSubjectId"
                                    v-model="paramQueryData.subjectId" :options="listDataSubject">
                                    <!-- <option value=0>Tất cả</option> -->
                                </b-form-select>
                            </div>
                        </div>
                        <div class="wrap-right">
                            <a href="javascript:;"
                                class="item btn btn-main border-rd-20 font-size-16 display-flex-center item__add"
                                @click="handleJoinClassSchool">
                                <img class="icon-plus" src="@/assets/img/plus.png" />
                                <img class="icon-plus" src="@/assets/img/plus-hover.png" />
                                Vào lớp học
                            </a>
                        </div>
                    </div>
                    <!-- <b-collapse id="collapse_filter" class="mt-2" :visible="openCollapseFilterGroup">
                        <FilterCollapse :isHideFilterClass="isHideFilterClass"
                            @handleOnFilterCollapse="handleOnFilterCollapse" />
                    </b-collapse> -->
                    <div class="class-school-list-item">
                        <div class="row">
                            <div class="col-md-4 col-sm-4" v-for="(item, index) of listDataClassSchool" :key="index">
                                <ItemClassSchool :type="1" :item="item"
                                    @handleLeaverClassSchool="handleLeaverClassSchool" />
                            </div>

                        </div>
                        <div class="row pagination container m-0">
                            <b-pagination pills v-model="paramQueryData.pageIndex" :total-rows="totalRecords"
                                :per-page="paramQueryData.pageSize" first-number last-number></b-pagination>
                        </div>
                    </div>
                    <ModalJoinClassSchool v-if="isShowModalJoinClassSchool" @handleDone="handleDone"
                        @closeModal="closeModal" />
                    <ModalLeaveClassSchool v-if="isShowModalLeaverClassSchool" @handleDone="handleDone"
                        @closeModal="closeModalLeaver" :classSchoolId="classSchoolId" />
                </b-tab>
                <b-tab title="Trang cá nhân" :active="tabActive === tabPersionalPage">
                    <member_personal_page :isReloadData="isReloadData" />
                </b-tab>
            </b-tabs>

        </div>
    </section>
</template>

<script>
import { getAuth } from "@/utils/jwt";
import { ROLE_TEACHER, ROLE_PUPIL } from "@/store/auth/constants";
import ItemClassSchool from './../_components/ItemClassSchool.vue';
import debounce from "@/directives/debounce";
import FilterCollapse from './../_components/FilterCollapse.vue';
import { getListClassSchoolMember } from './../_api/classSchoolServices';
import ModalJoinClassSchool from './../_components/ModalJoinClassSchool.vue';
import ModalLeaveClassSchool from './../_components/ModalLeaveClassSchool.vue';
import member_personal_page from './member_personal_page'
import { getAllTypeFilter } from './../_api/'

export default {
    name: 'ClassSchool',
    directives: { debounce },
    components: {
        ItemClassSchool,
        FilterCollapse,
        ModalJoinClassSchool,
        ModalLeaveClassSchool,
        member_personal_page
    },
    watch: {
        'paramQueryData.pageIndex': 'getDataClassSchool',
        'paramQueryData.keyword': 'filterDataByKeyword'
    },
    data() {
        return {
            tabActive: 1,
            tabClassSchool: 1,
            tabPersionalPage: 2,
            isShowModalJoinClassSchool: false,
            isShowModalLeaverClassSchool: false,
            isHideFilterClass: true,
            listDataClassSchool: [],
            classSchoolId: 0,
            paramQueryData: {
                keyword: '',
                pageIndex: 1,
                pageSize: 6,
                subjectId: 0,
                classId: 0
            },
            totalRecords: 0,
            nameRouteExam: 'danh-sach-lop-hoc',
            openCollapseFilterGroup: false, //đóng mở bộ lọc
            authInfo: getAuth(),
            roleTeacher: ROLE_TEACHER,
            roleHocSinh: ROLE_PUPIL,
            listDataSubject: [{ value: 0, text: "Môn học - Tất cả" },],
            isReloadData: false
        }
    },
    mounted() {

        // if (this.authInfo.roleCode == this.roleTeacher) {
        //     this.$router.push('/lop-hoc')
        // } else if (this.authInfo.roleCode == this.roleHocSinh) {
        //     this.$router.push('/danh-sach-lop-hoc')
        // } else {
        //     this.$router.push('/')
        // }
        if (this.authInfo.roleCode !== this.roleHocSinh && this.authInfo.roleCode !== this.roleTeacher) {
            this.$router.push('/')
        }
        // if (this.authInfo.roleCode !== this.roleHocSinh && this.authInfo.roleCode !== this.roleTeacher) {
        //     this.$router.push('/')
        // }
        this.getDataClassSchool()
        this.getTypesFilter()
    },
    methods: {
        handleChangeSubjectId() {
            this.getDataClassSchool()
        },
        getTypesFilter() {
            let self = this
            self.listDataSubject = [{ value: 0, text: "Môn học - Tất cả" },]
            this.subjectId = 0
            getAllTypeFilter({ classId: 0 }).then(res => {
                if (res && res.data && !res.errors) {
                    for (let i = 0; i < res.data.ltsSubject.length; i++) {
                        const item = res.data.ltsSubject[i];
                        self.listDataSubject.push({ value: item.subjectId, text: item.name })
                    }
                }
            })
        },
        closeModalLeaver() {
            this.isShowModalLeaverClassSchool = false
        },
        closeModal() {
            this.isShowModalJoinClassSchool = false
        },

        showModalJoinClassSchool() {
            this.isShowModalJoinClassSchool = true
        },
        handleLeaverClassSchool(id) {
            this.classSchoolId = id
            this.isShowModalLeaverClassSchool = true
        },

        handleJoinClassSchool() {
            this.showModalJoinClassSchool()
        },
        toggleCollapseGroup() {
            this.openCollapseFilterGroup = !this.openCollapseFilterGroup
        },
        handleDone() {
            this.filterDataByKeyword()
            this.isReloadData = true
        },
        filterDataByKeyword() {
            this.paramQueryData.pageIndex = 1
            this.getDataClassSchool()
        },
        handleOnFilterCollapse(filter) {
            this.paramQueryData.subjectId = filter.subjectId
            this.paramQueryData.classId = filter.classId
            this.getDataClassSchool()
        },
        getDataClassSchool() {
            let self = this

            getListClassSchoolMember({
                keyword: this.paramQueryData.keyword.trim(),
                pageIndex: this.paramQueryData.pageIndex,
                pageSize: this.paramQueryData.pageSize,
                subjectId: this.paramQueryData.subjectId,
                classId: this.paramQueryData.classId,
                sort: 'CreateAt',
                direction: 'desc',
            }).then(res => {
                if (res && res.data && !res.errors) {
                    self.listDataClassSchool = res.data.list
                    self.totalRecords = res.data.paging.totalRecords
                }
            })
        }

    }
}
</script>
<style>
.custom-select {
    height: 30px;
}
</style>
<style lang="scss" scoped>
.filter-btn {
    line-height: 20px;
    margin-left: 20px;
}

.pagination {
    margin-bottom: 20px;
}

.justify-content-between {
    justify-content: space-between;
}

.display-flex-space-between {
    justify-content: space-between;
}

.pre-class-school-list__filter__action {
    margin-top: 40px;
}

.class-school-list-item {
    margin-top: 10px;
}

.icon-plus {
    width: 20px;
    top: 0px !important;
    display: inline-block;
}

.list-subject {
    width: max-content;
    padding-right: 25px !important;
}
</style>